import type {SenseAction} from 'src/action-creators/types';

import type {QueueBasedInbox} from 'src/types/chat/queues';

import {
  RECEIVE_QUEUE,
  RECEIVE_QUEUE_BASED_INBOXES,
  UPDATE_QUEUE_JOIN_LOAD_STATE,
  UPDATE_QUEUE_BASED_INBOXES,
  RECEIVE_QUEUE_NOTIFICATION_ID,
} from 'src/action-creators/chat/queues';


export type State = {
  queue_based_inboxes: {
    [id: string]: QueueBasedInbox;
  };
  queues: Record<any, any>;
  isLoading: boolean;
  notificationId: string;
};

const initialState = {
  queue_based_inboxes: {},
  queues: {},
  isLoading: false,
  notificationId: '',
} as const;

export default function reduce(
  state: State | null | undefined = initialState,
  action: SenseAction,
): State {
  switch (action.type) {
    case RECEIVE_QUEUE_BASED_INBOXES: {
      const queues = action?.payload?.queue_based_inboxes || [];
      const nextInboxes: Record<string, any> = {};
      for (const queue of queues) {
        nextInboxes[queue.id] = queue;
      }

      // @ts-expect-error - TS2322 - Type '{ queue_based_inboxes: Record<string, any>; queues?: Record<any, any> | undefined; isLoading?: boolean | undefined; notificationId?: string | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        queue_based_inboxes: nextInboxes,
      };
    }

    case RECEIVE_QUEUE: {
      const queueId = action.payload.id;
      const nextQueues = {
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        ...state.queues,
        [queueId]: action.payload,
      } as const;

      // @ts-expect-error - TS2322 - Type '{ queues: { readonly [x: string]: any; }; queue_based_inboxes?: { [id: string]: QueueBasedInbox; } | undefined; isLoading?: boolean | undefined; notificationId?: string | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        queues: nextQueues,
      };
    }

    case UPDATE_QUEUE_BASED_INBOXES: {
      const queueId = action.payload.id;
      // @ts-expect-error - TS2322 - Type '{ queue_based_inboxes: { [x: string]: QueueBasedInbox; }; queues?: Record<any, any> | undefined; isLoading?: boolean | undefined; notificationId?: string | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        queue_based_inboxes: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.queue_based_inboxes,
          [queueId]: action.payload,
        },
      };
    }

    case UPDATE_QUEUE_JOIN_LOAD_STATE: {
      // @ts-expect-error - TS2322 - Type '{ isLoading: boolean; queue_based_inboxes?: { [id: string]: QueueBasedInbox; } | undefined; queues?: Record<any, any> | undefined; notificationId?: string | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        isLoading: action.payload,
      };
    }

    case RECEIVE_QUEUE_NOTIFICATION_ID: {
      // @ts-expect-error - TS2322 - Type '{ notificationId: string; queue_based_inboxes?: { [id: string]: QueueBasedInbox; } | undefined; queues?: Record<any, any> | undefined; isLoading?: boolean | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        notificationId: action.payload,
      };
    }
  }

  // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
  return state;
}
